import { useCallback, useState } from "react";

interface FieldState {
	valid: boolean;
	fieldType: string;
}

export const useAdyenValidation = () => {
	const [validFields, setValidFields] = useState(new Set<string>());

	const updateFieldValidity = useCallback((state: FieldState) => {
		setValidFields((prev) => {
			const newSet = new Set(prev);

			if (state.valid) {
				newSet.add(state.fieldType);
			} else {
				newSet.delete(state.fieldType);
			}

			return newSet;
		});
	}, []);

	const isCardValid = validFields.size === 3;

	return {
		isCardValid,
		updateFieldValidity,
	};
};
